export default {
  'pages.login.rememberMe': 'Ingat saya',
  'pages.login.forgotPassword': 'Lupa Kata Sandi?',
  'pages.welcome.alertMessage':
    'Komponen heavy-duty yang lebih cepat dan lebih kuat telah dirilis.',
  'pages.admin.subPage.title': 'Halaman ini hanya dapat dilihat oleh admin',
  delete: 'Hapus',
  edit: 'Ubah',
  cancel: 'Batal',
  clear: 'Bersihkan',
  new: 'Baru',
  update: 'Perbarui',
  undo: 'Batalkan',
  option: 'Opsi',
  details: 'Detail',
  deleting: 'Menghapus',
  createdAt: 'Dibuat Pada',
  firstSeen: 'Pertama Terlihat',
  lastActive: 'Terakhir Aktif',
  'idle.title': 'Sesi Anda akan segera berakhir',
  'idle.content': 'Lanjutkan sesi sekarang atau keluar',
  resume: 'Lanjutkan',
  name: 'Nama',
  'success.reloading': 'Berhasil, memuat ulang halaman',
  'fail.retry': 'Gagal, silakan coba lagi',
  tags: 'Tag',
  after: 'Setelah',
  flow: 'Alur',
  text: 'Teks',
  image: 'Gambar',
  video: 'Video',
  file: 'Berkas',
  custom: 'Kustom',
  input: 'Input',
  quickReplies: 'Balasan Cepat',
  ctaUrl: 'URL CTA',
  button: 'Tombol',
  question: 'Pertanyaan',
  fieldRequired: 'Bidang ini wajib diisi',
  entity: 'Entitas',
  active: 'Aktif',
  inactive: 'Tidak Aktif',
  deleted: 'Dihapus',
  next: 'Berikutnya',
  category: 'Kategori',
  portalUser: 'Pengguna Portal',
  role: 'Peran',
  admin: 'Admin',
  user: 'Pengguna',
  username: 'Nama Pengguna',
  email: 'Email',
  firstName: 'Nama Depan',
  lastName: 'Nama Belakang',
  fullName: 'Nama Lengkap',
  resetPassword: 'Atur Ulang Kata Sandi',
  'resetPassword.emailSent': 'Email pengaturan ulang kata sandi telah dikirim ke pengguna',
  'resetPassword.confirm.title': 'Atur ulang kata sandi untuk pengguna ini?',
  'resetPassword.confirm.content':
    'Email pengaturan ulang kata sandi akan dikirim ke {username} ({email})',
  'resetPassword.emailFailed': 'Gagal mengirim email pengaturan ulang, silakan coba lagi',
  'resetPassword.tokenExpired': 'Token Atur Ulang Kata Sandi telah kedaluwarsa',
  oldPassword: 'Kata Sandi Saat Ini',
  newPassword: 'Kata Sandi Baru',
  'password.characterNotMet':
    'Kata sandi harus berisi setidaknya satu huruf, satu angka, dan satu karakter khusus',
  confirmPassword: 'Konfirmasi Kata Sandi',
  'confirmPassword.mismatch': 'Kedua kata sandi yang Anda masukkan tidak cocok!',
  unlock: 'Buka Kunci',
  'portalUser.unlock.title': 'Buka kunci pengguna ini',
  'portalUser.unlock.content':
    '{username} ({email}) - Email pengaturan ulang kata sandi akan dikirim ke pengguna jika berlaku',
  'portalUser.userPasswordModal.title': 'Modal Kata Sandi Pengguna',
  logout: 'Keluar',
  dormant: 'Dorman',
  'portalUser.dormant.title': 'Apakah Anda yakin ingin membuat pengguna ini dorman?',
  'portalUser.dormant.content':
    '{username} ({email}) - Harap dicatat bahwa setelah menjadi dorman, pengguna ini tidak akan dapat lagi mengakses portal ini',
  reactivate: 'Aktifkan Kembali',
  'portalUser.reactivate.title': 'Apakah Anda yakin ingin mengaktifkan kembali pengguna ini?',
  'portalUser.reactivate.content':
    '{username} ({email}) - Harap dicatat bahwa setelah diaktifkan kembali, pengguna ini akan langsung mendapatkan akses ke portal ini',
  'portalUser.delete.title': 'Apakah Anda yakin ingin menghapus pengguna ini?',
  'portalUser.delete.content':
    '{username} ({email}) - Harap dicatat bahwa setelah dihapus, pengguna ini tidak akan dapat lagi mengakses portal ini. Data pribadi akan dihapus, atau Anda dapat memilih untuk membuat pengguna ini dorman.',
  'portalUser.delete.undo': '{username} ({email}) dihapus',
  'portalUser.emailChange.title': 'Ubah email pengguna?',
  'portalUser.emailChange.content':
    'Email akan diperbarui menjadi {newEmail} dan email pengaturan ulang kata sandi akan dikirim ke alamat tersebut. Pengguna akan keluar dan harus mengatur kata sandi baru untuk masuk kembali.',
  'portalUser.emailChange.noEmail.content':
    'Email akan diperbarui menjadi {newEmail}. Layanan email belum dikonfigurasi untuk organisasi ini, sehingga kata sandi baru akan dibuat dan ditampilkan kepada Anda untuk dibagikan ke pengguna.',
  platform: 'Platform',
  notes: 'Catatan',
  'pages.review.title': 'Review',
  'pages.review.description':
    'Hasilkan tinjauan terstruktur dari satu atau beberapa dokumen berdasarkan Daftar Pertanyaan Anda',
  'pages.file.placeholder.type': 'Jenis',
  'pages.file.placeholder.people': 'Pembuat',
  'pages.file.placeholder.search': 'Cari file atau folder',
  'pages.file.placeholder.editfile': 'Ubah Nama File',
  'pages.file.pdf': 'PDF',
  'pages.file.document': 'Dokumen',
  'pages.file.msg': 'MSG',
  'pages.file.eml': 'EML',
  'pages.file.txt': 'Teks',
  'pages.file.md': 'Markdown',
  'pages.file.excel': 'Excel',
  'pages.file.powerpoint': 'PowerPoint',
  'pages.file.uploading': 'Mengunggah',
  'pages.file.clickDragFile': 'Klik atau seret file ke sini untuk mengunggah',
  'pages.file.createfolder': 'Buat Folder',
  'pages.file.uploadFiles': 'Unggah File',
  'pages.file.upload.time': 'Waktu Unggah:',
  'pages.file.created.time': 'Waktu Dibuat:',
  'pages.file.favorites': 'Favorit Saya',
  'pages.file.history': 'Riwayat Revisi',
  'pages.file.success': 'Berhasil dibuat',
  'pages.file.filePreview': 'Pratinjau File',
  'pages.file.prompt.uploadFiled': 'Gagal mengunggah',
  'pages.file.prompt.network': 'Kesalahan Jaringan',
  'pages.file.prompt.fetchFiles': 'Gagal mendapatkan informasi daftar file',
  'pages.file.prompt.createGroup': 'Gagal membuat grup',
  'pages.file.prompt.createFolderSucc': 'Folder berhasil dibuat',
  'pages.file.prompt.createFolderFail': 'Gagal membuat folder',
  'pages.file.prompt.updateSucc': 'Berhasil diperbarui',
  'pages.file.prompt.updateFail': 'Gagal memperbarui',
  'pages.file.prompt.addFavoriteFail': 'Gagal ditambahkan',
  'pages.file.prompt.noPermission': 'Anda tidak memiliki izin untuk mengubah sesi ini',
  'pages.file.prompt.duplicateName': 'Nama sesi duplikat',
  'pages.file.prompt.notFound': 'Sesi tidak ditemukan',
  'pages.file.prompt.deleteGroupSuc': 'Berhasil dihapus',
  'pages.file.prompt.uploadFiles': 'file siap diunggah',
  'pages.file.prompt.downloadSucc': 'Berhasil diunduh',
  'pages.file.prompt.downloadFail': 'Gagal mengunduh',
  'pages.file.prompt.authFail': 'Token otorisasi tidak ada.',
  'pages.file.prompt.moveSucc': 'File berhasil dipindahkan',
  'pages.chat.newWithUploadedDocument': 'Obrolan Baru Dengan Dokumen',
  'pages.chat.editSessionName': 'Ubah Nama Sesi',
  'pages.chat.placeholder.inputSessionName': 'Masukkan nama sesi baru',
  'pages.chat.placeholder': 'Tulis sesuatu yang ingin Anda tanyakan...',
  'pages.chat.word': '/10000 karakter',
  'pages.chat.rateMessage.successfulLike': 'Berhasil menyukai pesan',
  'pages.chat.rateMessage.successfulDislike': 'Berhasil tidak menyukai pesan',
  'pages.chat.actions.like': 'Respons bagus',
  'pages.chat.actions.dislike': 'Respons buruk',
  'pages.chat.rateMessage.error': 'Gagal menilai pesan',
  'pages.chat.selectContext.setFilePriority.success': 'Prioritas File berhasil diperbarui',
  'pages.chat.selectContext.setFilePriority.error': 'Kesalahan saat memperbarui Prioritas File',
  'pages.chat.selectContext.toolTipDefault':
    'Secara default, bot akan memiliki akses ke semua file yang dapat Anda akses.',
  'pages.chat.rerank':
    'Mengurutkan ulang hasil pencarian sebelum mengembalikan hasil. Ini dapat meningkatkan kualitas hasil tetapi membuat pencarian jauh lebih lambat.',
  'pages.chat.selectContext.tootlTipRestrict':
    'Anda dapat menggunakan menu ini untuk membatasi file yang tersedia untuk model.',
  'pages.chat.hybridSearchAlphaTooltip':
    'Rasio pencarian mengontrol keseimbangan antara pencarian semantik dan kata kunci. Nilai rendah mengutamakan pencarian kata kunci, sedangkan nilai tinggi mengutamakan pencarian semantik.',
  'pages.chat.favoriteFileWeight':
    'Bobot ini secara artifisial meningkatkan peringkat pencarian file yang difavoritkan.',
  'pages.dashboard.realTimeUsersTitleTooltip':
    'Jumlah pengguna yang saat ini berinteraksi dengan bot atau telah berinteraksi dengan bot dalam 5 menit terakhir.',
  'pages.dashboard.activeUsersTitleTooltip':
    'Jumlah pengguna yang telah berinteraksi dengan bot selama periode yang dipilih.',
  'pages.dashboard.newUsersTitleTooltip':
    'Jumlah pengguna yang berinteraksi dengan bot untuk pertama kalinya selama periode yang dipilih.',
  'pages.dashboard.promptTokensTitleTooltip':
    'Jumlah token input yang diproses selama periode yang dipilih.',
  'pages.dashboard.completionTokensTitleTooltip':
    'Jumlah token output yang dihasilkan selama periode yang dipilih.',
  'pages.dashboard.userMessagesTitleTooltip':
    'Jumlah pesan yang dikirim oleh pengguna selama periode yang dipilih.',
  'pages.dashboard.storyboardsTitleTooltip':
    'Jumlah pesan pengguna yang ditangani oleh storyboard chatbot bawaan selama periode yang dipilih.',
  'pages.dashboard.botMessagesTitleTooltip':
    'Jumlah pesan yang dikirim ke pengguna oleh bot selama periode yang dipilih.',
  'pages.dashboard.broadcastsTitleTooltip':
    'Jumlah pesan yang dikirim ke pengguna yang diprakarsai oleh bot melalui fungsi Siaran selama periode yang dipilih.',
  'pages.dashboard.repliesTitleTooltip':
    'Jumlah pesan yang dikirim ke pengguna sebagai balasan atas pesan pengguna selama periode yang dipilih.',
  'pages.dashboard.messageExchangesTitleTooltip':
    'Jumlah pertukaran pesan antara pengguna dan bot selama periode yang dipilih.',
  'pages.dashboard.broadcastTitleTooltip':
    'Jumlah siaran yang diprakarsai oleh bot selama periode yang dipilih.',
  'pages.dashboard.outReachTitleTooltip':
    'Jumlah total penerima dari semua siaran selama periode yang dipilih.',
  'pages.chat.stopGenerating': 'Berhenti menghasilkan.',
  'pages.chat.stopGenerating.error': 'Gagal menghentikan proses menghasilkan.',
  'pages.app.timeline': 'Linimasa',
  'pages.app.guided_summary': 'Ringkasan Terpandu',
  'pages.app.standard_info': 'Info Singkat',
  'pages.login.microsoftSSO': 'Masuk dengan Microsoft',
  'pages.login.loading': 'Memuat...',
  'pages.login.redirectingToMS': 'Mengalihkan ke Microsoft SSO...',
  'pages.loggedOut.title': 'Keluar',
  'pages.loggedOut.heading': 'Anda telah keluar',
  'pages.loggedOut.description':
    'Anda dapat menutup jendela ini atau kembali ke halaman masuk untuk masuk kembali.',
  'pages.loggedOut.return': 'Kembali ke halaman masuk',
};
